var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_4050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9348 7.85095L22.0093 19.7765C20.6796 21.1028 18.8781 21.8477 17 21.8477C15.1219 21.8477 13.3204 21.1028 11.9907 19.7765L0.0651667 7.85095C0.0453333 8.07479 0 8.27737 0 8.49979V25.4998C0.00224946 27.3777 0.749249 29.1781 2.07714 30.506C3.40504 31.8339 5.20541 32.5809 7.08333 32.5831H26.9167C28.7946 32.5809 30.595 31.8339 31.9229 30.506C33.2508 29.1781 33.9977 27.3777 34 25.4998V8.49979C34 8.27737 33.9547 8.07479 33.9348 7.85095Z",
    fill: "#1D72D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0062 17.7733L32.9461 4.83203C32.3192 3.79264 31.4351 2.93233 30.379 2.33406C29.323 1.73579 28.1305 1.41976 26.9167 1.41644H7.08341C5.86964 1.41976 4.6772 1.73579 3.62112 2.33406C2.56503 2.93233 1.68092 3.79264 1.05408 4.83203L13.9939 17.7733C14.7923 18.5685 15.8732 19.0149 17.0001 19.0149C18.1269 19.0149 19.2079 18.5685 20.0062 17.7733Z",
    fill: "#1D72D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_4050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d5c99ed40035ac032672ee06f466301b.svg";
export { ForwardRef as ReactComponent };